import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes, Utils } from "../../../wayin-react";
import { toUIProps } from "../../../util";
import { removeProps, whitelistStyles, mapHandlers } from "../hoc";
import { compose } from 'react-recompose';
import classnames from 'classnames';
import { font, sizes, textOverflows, colors } from "../../../enums";
import { Card as UICard } from 'semantic-ui-react';
import Image from "../image";
var UNSUPPORTED_PROPS = ['as', 'className', 'color', 'centered', 'fluid', 'raised', //  may add later
'extra'];
var ADDED_PROPS = ['id', 'font', 'isCentered', 'isFluid', 'isInverted', 'headerStyles', 'descriptionStyles', 'children'];
var MODIFIED_PROPS = ['meta'];
var propMap = {
  isCentered: 'centered',
  isFluid: 'fluid',
  isRaised: 'raised'
};
export var OnHover = createComponent({
  displayName: 'Card.OnHover',
  propTypes: {
    children: PropTypes.node.isRequired,
    isDimmed: PropTypes.bool.isRequired,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    color: PropTypes.oneOf([colors.WHITE]) //other colors to be added later

  },
  defaultProps: {
    color: undefined
  },
  render: function render(props) {
    var _classnames;

    var wrapperClass = classnames({
      'image': true,
      'dimmed': props.isDimmed
    });
    var contentClass = classnames((_classnames = {
      'hover-content': true
    }, _classnames["hover-background-" + props.color] = !!props.color, _classnames['dimmed'] = props.isDimmed, _classnames));
    return /*#__PURE__*/React.createElement("div", {
      className: "card-hoverable-child"
    }, /*#__PURE__*/React.createElement("div", {
      className: wrapperClass
    }, /*#__PURE__*/React.isValidElement(props.image) ? props.image : /*#__PURE__*/React.createElement(Image, {
      src: props.image
    })), /*#__PURE__*/React.createElement("div", {
      className: contentClass
    }, /*#__PURE__*/React.createElement("div", {
      className: "hoverable-content"
    }, props.children)));
  }
});
var Card = createComponent({
  displayName: 'Card',
  propTypes: {
    header: PropTypes.string,
    description: PropTypes.string,
    href: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    meta: PropTypes.any,
    isCentered: PropTypes.bool,
    isFluid: PropTypes.bool,
    onClick: PropTypes.func,
    headerStyles: PropTypes.shape({
      size: PropTypes.oneOf(sizes.S_M_L),
      font: PropTypes.shape({
        weight: PropTypes.oneOf(font.weights.ALL),
        family: PropTypes.oneOf(font.families.ALL),
        emphasis: PropTypes.oneOf(font.emphasis.ALL)
      }),
      textOverflow: PropTypes.string
    }),
    descriptionStyles: PropTypes.shape({
      textOverflow: PropTypes.string
    }),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  },
  defaultProps: {
    header: undefined,
    description: undefined,
    href: undefined,
    image: undefined,
    meta: undefined,
    isCentered: undefined,
    isFluid: undefined,
    onClick: undefined,
    headerStyles: undefined,
    descriptionStyles: undefined,
    value: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  state: {
    isDimmed: {
      value: false,
      updater: function updater(setIsDimmed) {
        return {
          dim: function dim() {
            return setIsDimmed(true);
          },
          undim: function undim() {
            return setIsDimmed(false);
          }
        };
      }
    }
  },
  render: function render(p) {
    // merge the props with defaultProps, making sure to take account of headerStyles
    var props = _.defaults(p, defaultProps);

    var children = React.Children.toArray(props.children);

    var overlayChild = _findInstanceProperty(children).call(children, function (child) {
      return Utils.isType(OnHover, child);
    });

    var unsupportedChildren = _findInstanceProperty(children).call(children, function (child) {
      return !Utils.isType(OnHover, child);
    });

    var dim = props.dim,
        undim = props.undim;
    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });
    delete UIProps.children;
    delete UIProps.image;
    delete UIProps.header;
    delete UIProps.description;
    delete UIProps.isDimmed;
    delete UIProps.dim;
    delete UIProps.undim;
    var fontStyles = {
      weight: props.headerStyles.font && props.headerStyles.font.weight || font.weights.REGULAR,
      family: props.headerStyles.font && props.headerStyles.font.family || font.families.CUSTOM
    };
    UIProps.className = classnames('ck-card', {
      inverted: props.isInverted
    });
    var headerClassName = classnames(props.headerStyles.size, "font-" + fontStyles.family + "-" + fontStyles.weight, _extends({
      caps: isEmphasisCaps(props)
    }, mapTextOverflow(props.headerStyles))); //loggers

    logger.warn('Card: incorrect child supplied. Please only use Card.OnHover', !!unsupportedChildren);
    logger.warn('Card: Please supply image prop if you plan to use Card.OnHover', !props.image && !!overlayChild);
    var descriptionClassName = classnames(_extends({}, mapTextOverflow(props.descriptionStyles)));
    return /*#__PURE__*/React.createElement(UICard, _extends({}, UIProps, {
      onMouseEnter: dim,
      onMouseLeave: undim
    }), !!props.image ? !overlayChild ? /*#__PURE__*/React.createElement("div", {
      className: "image"
    }, /*#__PURE__*/React.isValidElement(props.image) ? props.image : /*#__PURE__*/React.createElement(Image, {
      src: props.image
    })) : /*#__PURE__*/React.cloneElement(overlayChild, {
      isDimmed: props.isDimmed,
      image: props.image
    }) : null, !!props.header || !!props.description || !!props.meta ? /*#__PURE__*/React.createElement(UICard.Content, null, !!props.header ? /*#__PURE__*/React.createElement(UICard.Header, {
      className: headerClassName,
      content: props.header
    }) : null, !!props.description ? /*#__PURE__*/React.createElement(UICard.Description, {
      className: descriptionClassName,
      content: props.description
    }) : null, !!props.meta ? /*#__PURE__*/React.createElement(UICard.Meta, {
      content: props.meta
    }) : null) : null);
  }
});
var defaultProps = {
  description: undefined,
  header: undefined,
  href: undefined,
  image: undefined,
  meta: undefined,
  onClick: undefined,
  isCentered: false,
  isFluid: false,
  headerStyles: {
    size: sizes.LARGE,
    font: {
      weight: font.weights.REGULAR,
      family: font.families.CUSTOM,
      emphasis: font.emphasis.NORMAL
    },
    textOverflow: textOverflows.WRAP
  },
  descriptionStyles: {
    textOverflow: textOverflows.WRAP
  },
  value: undefined
};

function mapTextOverflow(p) {
  var _ref;

  var textOverflow = p.textOverflow;
  return _ref = {}, _ref["text-overflow-" + textOverflow] = _.isString(textOverflow), _ref;
}

function isEmphasisCaps(props) {
  // legacy `textEmphasis` prop - keep backwards compatible
  logger.deprecation("Prop \"textEmphasis\" has been deprecated, and can conflict with\n    \"font: emphasis\", please remove \"textEmphasis\" from Card.", !!props.headerStyles.textEmphasis);
  return props.headerStyles.textEmphasis === font.emphasis.CAPS || !props.headerStyles.textEmphasis && props.headerStyles.font && props.headerStyles.font.emphasis === font.emphasis.CAPS;
}

export var PrivateCard = mapHandlers({
  click: []
})(Card);
export default compose(removeProps(['isRaised']), whitelistStyles())(PrivateCard);
//# sourceMappingURL=card.js.map